

function ResetFlags(props) {

    function resetFlags() {
        const confirmBox = window.confirm(
            "Do you really want to Reset Dev Flags"
        )
        if (confirmBox === true) {
            console.log("resetting Flags")
            // localStorage.clear(); // Clears all keys
            localStorage.removeItem('Preferences'); // Clears one key 
            localStorage.removeItem('FLAGS'); // Clears one key 
        }
    }
    return (<button onClick={() => resetFlags()}>ResetFlags</button>)
}


export default ResetFlags;